import React, { useState, useEffect } from 'react'
import { Row, Col, Typography, Card } from 'antd'
import AliceCarousel from 'react-alice-carousel'
import { HeaderHero, SEO } from './components'
import { ROADSIDE_ASSISTANCE_BREAK_POINTS, ROADSIDE_ASSISTANCE_ARRAY } from '../constants'
import { useWindowSize } from '../utils'

import RoadsideStyle from '../../styles/RoadsideAssistance.module.css'
import 'react-alice-carousel/lib/alice-carousel.css'

const tabletImage = 'hero/rsa/RSA_1024x300-no-copy.jpg'
const desktopImage = 'hero/rsa/RSA_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/rsa/RSA_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/rsa/RSA_1960x300-no-copy.jpg'
const smallImage = 'hero/rsa/RSA_375x188.jpg'
const smallImage390 = 'hero/rsa/RSA_390x188.jpg'
const mobileImage = 'hero/rsa/RSA_428x188.jpg'
const mobileImage768 = 'hero/rsa/RSA_768x300-no-copy.jpg'

const { Link, Text, Title } = Typography

const RoadsideAssistance = ({ }) => {
  
  return (
    <>
      <SEO
        description="When the unexpected happens, you're covered 24/7 with CURE Roadside Assistance. Claims support 24/7 for NJ, PA & MI drivers."
        title="Roadside Assistance | CURE Auto Insurance"
        url="/roadside"
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        title="ROADSIDE ASSISTANCE"
        xtraLargeScreenImage={xtraLargeScreenImage}
      />
      {
        (() => {
          return (
            <Card className={`${RoadsideStyle["roadside-select"]}`} style={{margin: "auto", maxWidth: "1140px", width: "100%", display: "flex", height: "100%"}}>
              <Row className={`${RoadsideStyle["description"]}`}>
                <span className={`${RoadsideStyle["roadside-description"]}`} style={{color: "#000", fontWeight: "400", fontSize: "23px", textTransform: "none", marginBottom: "15px"}}>Please select your state to review Roadside Assistance coverage information.</span>
              </Row>
              <div className={`${RoadsideStyle["roadside-assistance-screen-states"]}`}>
                <div className={`${RoadsideStyle["roadside-drivers-row"]}`}>
                  <div>
                    <Link className={`${RoadsideStyle["mi-drivers"]} ${RoadsideStyle["mi-pop-up-button"]}`} href="/roadside/mi">
                      <img className={`${RoadsideStyle["mi-pop-up-button"]}`} alt="mi-drivers" />
                    </Link>
                  </div>
                  <div>
                    <Link className={`${RoadsideStyle["nj-drivers"]}`} href="/roadside/nj">
                      <img alt="nj-drivers" />
                    </Link>
                  </div>
                  <div>
                    <Link className={`${RoadsideStyle["pa-drivers"]}`} href="/roadside/pa">
                      <img alt="pa-drivers" />
                    </Link>
                  </div>
                </div>
              </div>
            </Card>
          )
        })()
      }
    </>
  )
}

RoadsideAssistance.propTypes = {}

export default RoadsideAssistance